import { render, staticRenderFns } from "./drop-down-loader.vue?vue&type=template&id=efb4c956"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "src/templates/oem-trim-level-finance/components/drop-down-loader.vue"
export default component.exports